<script>
import Zetrix from "../../utils/zetrix";
import ButtonOutline from "../buttons/buttonOutline.vue";
import notificationSound from "../../assets/sounds/notification.mp3";
import DialogNotification from "../dialogs/dialogNotification.vue";
import { mapActions } from "vuex";
export default {
  components: {
    ButtonOutline,
    DialogNotification,
  },
  mixins: [Zetrix],
  props: {
    noti: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      showDialogAccount: false,
      position: "center",
      duration: 1500,
      isCopied: false,
      pending: sessionStorage.getItem("notification"),
      receivedNoti: false,
      buttonName: "Connect Wallet",
      iconPlacement: "prepend",
      buttonIcon: "mdi-wallet-outline",
      snackbar: false,
      showDialogNotification: false,
      isJointExist: false,
      userName: sessionStorage.getItem('userName') || '',
      zetrixAccount: sessionStorage.getItem("zetrixAccount"),
    };
  },
  mounted() {
    if (!this.userName) {
      this.fetchUserDetails(this.zetrixAccount)
    }

  },
  computed: {
    convertZtx: function () {
      return this.balance / 1000000 + " ZTX";
    },
    isSmallScreen() {
      return this.$vuetify.display.xs;
    },
  },
  watch: {
    noti(newValue) {
      this.pending = newValue;
      this.receivedNoti = true;
      const audio = new Audio(notificationSound);

      audio.play();
      setTimeout(() => {
        this.receivedNoti = false;
      }, 5000);
    },

  },
  created() {
  },
  methods: {
    ...mapActions("users", ["userDetail"]),
    navigate(path) {
      this.$router.push({ name: path });
    },
    customProcess() {
      this.checkZetrixInstall();
    },
    toLoginZetrix() {
      this.checkZetrixInstall();
    },
    toLogoutZetrix() {
      this.showDialogAccount = false;
      this.disconnectWalletZtx();
    },
    handleCopiedEvent(isCopied) {
      this.isCopied = isCopied;
    },

    shortenUserName(string) {
      const len = string.length;
      if (len > 12) {
        return string.substr(0, 12) + "..." + string.substr(len - 14, len);
      } else {
        return string;
      }
    },
    shortenAddress(address) {
      if (!address) return "";
      const len = address.length;
      if (len <= 10) {
        return address;
      }
      return `${address.substr(0, 6)}...${address.substr(len - 4, 4)}`;
    },
    async copyAddress(text) {
      if (!text) return;

      // Try Clipboard API (only works on HTTPS / localhost)
      if (window.isSecureContext && navigator.clipboard?.writeText) {
        try {
          await navigator.clipboard.writeText(text);
          console.log("Copied with Clipboard API:", text);
          this.snackbar = true;
          return;
        } catch (err) {
          console.warn("Clipboard API failed, fallback to execCommand:", err);
        }
      }

      // Always fallback for HTTP / non-secure origins
      try {
        const ta = document.createElement("textarea");
        ta.value = text;
        ta.setAttribute("readonly", "");
        ta.style.position = "fixed";
        ta.style.top = "-9999px";
        document.body.appendChild(ta);

        ta.select();
        ta.setSelectionRange(0, ta.value.length); // mobile-friendly
        const successful = document.execCommand("copy");
        document.body.removeChild(ta);

        if (successful) {
          console.log("Copied with execCommand fallback:", text);
          this.snackbar = true;
        } else {
          console.error("execCommand copy failed");
        }
      } catch (err) {
        console.error("Fallback copy failed:", err);
      }
    },
    async fetchUserDetails(data) {
      const res = await this.userDetail(data);
      if (res.object) {
        this.userName = res.object.name
      }
    }
  },
  name: "NavBar",
};
</script>

<template>
  <v-container class="pa-4">
    <v-card class="user-card">
      <v-row align="center" justify="space-between">
        <!-- Left: Welcome Text -->
        <v-col cols="auto">
          <div class="d-flex flex-column">
            <span class="welcome-text">Welcome,</span>
            <span class="username-text">{{ userName }}</span>
          </div>
        </v-col>


        <!-- Right: Button -->
        <v-col cols="auto">
          <v-tooltip location="bottom">
            <template #activator="{ props }">
              <!-- Show button if account exists -->
              <ButtonOutline v-if="zetrixAccount !== null" v-bind="props" button-height="40"
              :button-width="isSmallScreen ? '140' : '180'" :button-name="shortenAddress(zetrixAccount)"
              :icon-placement="iconPlacement" :button-icon="buttonIcon" icon-type="image"
              @click="showDialogAccount = true" />

              <!-- Show button if no account -->
              <ButtonOutline v-else v-bind="props" button-height="40" :button-name="buttonName"
                @customProcess="customProcess" />
            </template>

            <!-- Tooltip text -->
            <span>{{ zetrixAccount || 'No account connected' }}</span>
          </v-tooltip>
        </v-col>

      </v-row>
    </v-card>
  </v-container>

  <!-- Start Disconnect Dialog -->
  <v-dialog v-model="showDialogAccount" width="450">
    <v-card>
      <v-card-text>
        Your connected wallet address
        <br />
        <b>{{ zetrixAccount }}
          <v-icon class="ml-2" @click="copyAddress(zetrixAccount)">
            mdi-content-copy
          </v-icon></b>
        <br />
        <div class="spacer"></div>
        <!-- <div class="d-flex dialog-balance">
          <span>Wallet balance</span>
          <b>{{ balance / 1000000 }} ZETRIX</b>
        </div> -->
        <v-card-actions class="justify-center">
          <ButtonOutline button-width="290" class="disconnect-btn" button-icon="mdi-power" icon-type="icon"
            icon-placement="prepend" button-name="Disconnect" button-size="large" @click="toLogoutZetrix" />
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
  <!-- End Disconnect Dialog -->



  <v-snackbar v-model="snackbar" :timeout="2000" :max-width="50">
    Address copied!
  </v-snackbar>
</template>

<style>
.user-card {
  padding: 24px;
}

.welcome-text {
  color: #92939E;
  font-size: 16px;
  font-family: 'Gilroy', sans-serif;
  font-weight: 500;
}

.username-text {
  color: black;
  font-size: 24px;
  font-family: 'Gilroy', sans-serif;
  font-weight: 700;
}

.nav-spacer {
  padding-right: 10px;
}

.responsive-img {
  max-width: 100%;
  height: auto;
  cursor: pointer;
}

.v-dialog>.v-overlay__content>.v-card>.v-card-text,
.v-dialog>.v-overlay__content>form>.v-card>.v-card-text {
  padding: 16px 24px 16px 24px;
}

.dialog-balance {
  justify-content: space-between;
}

.disconnect-btn {
  width: 280px;
}

.notification-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}

.notification-dialog {
  padding-top: 40px;
  display: flex;
  justify-content: end;
  align-items: start;
}
</style>
